import React from 'react';

import { bemCssModules, getTestId } from '@utils';

import Input, { TInput } from '@components/Input';

import SearchIcon from './search.svg';

import style from './Header.scss';

const cn = bemCssModules(style, 'Header');
const ti = getTestId('Header');

export type THeader = {
  label: string;
  search: string;
  onSearch: TInput['onChange'];
  placeholder: string;
  onEnter?: () => void;
};

const Header: CustomFC<THeader> = props => {
  const { className, label, search, onSearch, placeholder, onEnter } = props;

  const onKeyDown = e => {
    if (e.keyCode === 13) onEnter?.();
  };

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <div className={cn('title', ['h2'])}>{label}</div>
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className={cn('input-block')}>
        <SearchIcon />
        <Input
          value={search}
          onChange={onSearch}
          placeholder={placeholder}
          enterKeyHint="done"
          onKeyDown={onKeyDown}
        />
      </label>
    </div>
  );
};

export default Header;
